
import React from 'react';

interface MapLoadingStateProps {
  width: string | number;
  height: string | number;
}

export function MapLoadingState({ width, height }: MapLoadingStateProps) {
  return (
    <div 
      className="absolute inset-0 bg-gray-100 flex items-center justify-center" 
      style={{ width, height }}
    >
      <div className="animate-spin h-6 w-6 border-2 border-grandpal-green border-t-transparent rounded-full"></div>
    </div>
  );
}
